export default function getResource(label) {
    const resources = {
        noProducts: 'Désolé, aucun article ne correspond aux filtres appliqués.',
        showMore: 'Afficher plus',
        showLess: 'Afficher moins'
    };

    return resources[label];
}
